
<template>
  <div class="v-form-field-error mb-4">
    <div class="block v-form-error mt-2 mb-2">
      <p class="font-bold">Error</p>
      <slot />
    </div>
  </div>
</template>